export const CompaniesNames = {
  Vitel: 'Vitel Energia',
  Head: 'Head Chile',
  HeadTest: 'Head Test',
  Calu: 'Calu'

}

export const InstructionTypes = {
  FillInputByLabel: 'fill-input-by-label',
  FillInputByName: 'fill-input-by-name',
  FillInputById: 'fill-input-by-id',
  SelectOption: 'select-option',
  ClickInput: 'click-input',
  ClickButton: 'click-button',
  PaymentMethod: 'payment-method',
  ShippingMethod: 'shipping-method'
}
